/** Days before uploads and generations are deleted by the cleanup job. Keep in step with it. */
export const RETENTION_DAYS = 14;

/** True once a run is past the retention window, so its files are already gone from storage. */
export function isExpired(createdAt: string, now = Date.now()): boolean {
  return now - new Date(createdAt).getTime() > RETENTION_DAYS * 24 * 60 * 60 * 1000;
}

/**
 * True for a finished run whose files the clean-up has deleted. Failed and
 * pending runs never stored anything, so they keep showing as they are.
 */
export function hasExpiredFiles(run: { status: string; created_at: string }, now = Date.now()): boolean {
  return run.status === "completed" && isExpired(run.created_at, now);
}
